import { component } from 'picoapp';
import Swiper, { Navigation, Pagination, Autoplay } from 'swiper';

export default component((node, ctx) => {
  const swiper = new Swiper('.swiper', {
    modules: [Navigation, Pagination, Autoplay],
    autoplay: {
      delay: 3000,
    },
    spaceBetween: 20,
  });

  const sliderLogos = node.querySelectorAll('.testimonial-logo');

  sliderLogos.forEach(logo => {
    logo.addEventListener('click', () => {
      swiper.slideTo(logo.dataset.index);
    });
  });

  function setActiveLogo(index) {
    sliderLogos.forEach(logo => {
      logo.classList.remove('is-active');

      if (logo.dataset.index === index) {
        logo.classList.add('is-active');
      }
    });
  }

  swiper.on('realIndexChange', function () {
    setActiveLogo(swiper.realIndex.toString());
  });
});
